// @flow

import React from 'react';
import type { Node } from 'react';
import { FormattedMessage } from 'react-intl';

type Props = {
  livesCountry?: ?string,
  livesCity?: ?string,
};

/**
 * ArtistLivesText
 *
 * @param {Props} props
 * @returns {Node}
 */
export function ArtistLivesText({ livesCountry, livesCity }: Props): Node {
  if (!livesCountry && !livesCity) {
    return null;
  }

  return !livesCountry ? (
    livesCity
  ) : (
    <FormattedMessage id={`countries.${livesCountry}`}>
      {(livesCountry: string) =>
        `${livesCity || ''}${livesCity && livesCountry ? ', ' : ''}${livesCountry}`
      }
    </FormattedMessage>
  );
}
